export default "__VITE_ASSET__SU7ElFbo__"